import React from 'react';

export const PaymentRequestDetailPage = () => {
  return (
    <>
      <h2 className="mt-32 text-32 font-bold leading-normal">급여상세내역</h2>
    </>
  );
};
